import { ReactNode } from "react";

export default function isReactText(
  children: ReactNode
): children is string | number {
  return typeof children === "string" || typeof children === "number";
}
